<div class="col full-height layout-column" *ngIf="{ loading: (loading$ | async) } as vm">

  <app-resources-panel-list-item [resource]="resource"
                                 [settings]="settings.resources"
                                 [canClose]="true"
                                 (onClose)="onClose.emit()">

  </app-resources-panel-list-item>

  <div class="flex layout-column overflow-auto margin-top-5 position-relative">
    <div class="flex layout-column dndList"
         cdkDropList
         [cdkDropListData]="routes"
         id="{{panel.id}}"
         [cdkDropListConnectedTo]="allPanelIds"
         [cdkDropListSortPredicate]="sortPredicate"
         (cdkDropListEntered)="enter($event)"
         (cdkDropListDropped)="drop($event)">

      <app-routes-panel-list-item *ngFor="let route of routes; trackBy: trackByRouteId"
                                  cdkDrag
                                  [cdkDragData]="route"
                                  [cdkDragDisabled]="route.status === routeStatusType.Completed || route.status === routeStatusType.Canceled || route.status === routeStatusType.Deleted"
                                  [route]="route"
                                  [settings]="settings.routes"
                                  [isVisible]="visibleKeys[route.id]"
                                  [canShow]="true"
                                  [canLock]="true"
                                  (cdkDragStarted)="onDragStarted()"
                                  (cdkDragEnded)="onDragEnded()"
                                  (onDrillDown)="onDrillDownRoute.emit($event)"
                                  (onChangeRouteResource)="onChangeRouteInfo.emit({route: route, event: $event.event})"
                                  (onToggleVisible)="onToggleVisibleRoute.emit($event)"
                                  (onLockRouteChange)="onToggleLockedRoute($event)">
        <div cdkDragHandle>
          <bringoz-icon iconName="drag" class="secondary-100" [ngClass]="{disabled: route.status === routeStatusType.Completed || route.status === routeStatusType.Canceled || route.status === routeStatusType.Deleted}"></bringoz-icon>
        </div>

      </app-routes-panel-list-item>

      <ng-template cdkDropListPlaceholder>
        <div class="placeholder">Drop here</div>
      </ng-template>
    </div>

    <div *ngIf="!vm.loading && !routes?.length"
         class="flex-100 layout-row layout-align-center-center fade-element-in-only overflow-auto state-overlay">
      <app-empty-state src="assets/images/empty_state/empty_state_routes.png"
                       text="No Routes Found">

      </app-empty-state>
    </div>

  </div>

  <app-bringoz-linear-progress *ngIf="vm.loading"></app-bringoz-linear-progress>

</div>
